export const userConstants = {
    REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
    REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
    REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',
    
    UPDATE_REQUEST:'USERS_UPDATE_REQUEST',
    UPDATE_SUCCESS:'USERS_UPDATE_SUCCESS',
    UPDATE_FAILURE:'USERS_UPDATE_FAILURE',

    RESET_REQUEST: 'USERS_RESET_REQUEST',
    RESET_SUCCESS: 'USERS_RESET_SUCCESS',
    RESET_FAILURE: 'USERS_RESET_FAILURE',

    RESET_CONFIRM_REQUEST: 'USERS_RESET_CONFIRM_REQUEST',
    RESET_CONFIRM_SUCCESS: 'USERS_RESET_CONFIRM_SUCCESS',
    RESET_CONFIRM_FAILURE: 'USERS_RESET_CONFIRM_FAILURE',

    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

    LOGOUT: 'USERS_LOGOUT',

    GETUSER_REQUEST: 'USERDATA_GET_REQUEST',
    GETUSER_SUCCESS: 'USERDATA_GET_SUCCESS',
    GETUSER_FAILURE: 'USERDATA_GET_FAILURE',

    GETALL_REQUEST: 'USERS_GETALL_REQUEST',
    GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
    GETALL_FAILURE: 'USERS_GETALL_FAILURE',

    DELETE_REQUEST: 'USERS_DELETE_REQUEST',
    DELETE_SUCCESS: 'USERS_DELETE_SUCCESS',
    DELETE_FAILURE: 'USERS_DELETE_FAILURE'
};
